/**
 * NotFoundPage (iter1077) — дотук непознат адрес показваше празен екран
 * (нямаше маршрут „*"). Сега посетителят получава кратко обяснение и три
 * изхода, а адресната лента остава непроменена.
 */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Compass, Home, LayoutDashboard, Utensils } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";

export default function NotFoundPage() {
  const { isDark } = useTheme();
  const { pathname } = useLocation();

  const link = `inline-flex items-center gap-2 rounded-full px-4 min-h-[44px] text-sm font-bold transition-all ${
    isDark ? "bg-slate-800 text-slate-100 hover:bg-slate-700" : "bg-slate-100 text-slate-800 hover:bg-slate-200"
  }`;

  return (
    <div
      data-testid="not-found-page"
      className={`min-h-screen flex items-center justify-center px-5 py-16 ${
        isDark ? "bg-[hsl(222,47%,6%)] text-white" : "bg-[#F8FAFC] text-[#1A1A2E]"
      }`}
    >
      <div className="w-full max-w-md">
        <div className="w-14 h-14 rounded-2xl grid place-items-center bg-gradient-to-br from-violet-500 to-fuchsia-500 mb-5">
          <Compass className="w-7 h-7 text-white" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold">Тази страница я няма</h1>
        <p className={`mt-2 text-sm ${isDark ? "text-slate-400" : "text-slate-600"}`}>
          Адресът <span className="font-mono break-all">{pathname}</span> не отговаря на нито един раздел.
          Може да е остаряла препратка. Ето откъде да продължите:
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          <Link to="/" className={link} data-testid="not-found-home">
            <Home className="w-4 h-4" /> Начало
          </Link>
          <Link to="/dashboard" className={link} data-testid="not-found-dashboard">
            <LayoutDashboard className="w-4 h-4" /> Моят ден
          </Link>
          <Link to="/dashboard/diary" className={link} data-testid="not-found-diary">
            <Utensils className="w-4 h-4" /> Хранителен дневник
          </Link>
        </div>
      </div>
    </div>
  );
}
